<a [routerLink]="[link?.route]" routerLinkActive="active">
    <p class="link-on-hover">{{ link?.text }}</p>
</a>